import type { Venta } from '../types/content'

export const ventas: Venta[] = [
  { iniciales: 'FL', nombre: 'Fernanda L.', ciudad: 'Ciudad de México, México', hace: 'hace 2 minutos' },
  { iniciales: 'VP', nombre: 'Valentina P.', ciudad: 'Bogotá, Colombia', hace: 'hace 4 minutos' },
  { iniciales: 'MV', nombre: 'Mariana V.', ciudad: 'Buenos Aires, Argentina', hace: 'hace 6 minutos' },
  { iniciales: 'LR', nombre: 'Luisa R.', ciudad: 'Lima, Perú', hace: 'hace 9 minutos' },
  { iniciales: 'BM', nombre: 'Bárbara M.', ciudad: 'Santiago, Chile', hace: 'hace 12 minutos' },
  { iniciales: 'DG', nombre: 'Daniela G.', ciudad: 'Rosario, Argentina', hace: 'hace 15 minutos' },
  { iniciales: 'CA', nombre: 'Carolina A.', ciudad: 'Guadalajara, México', hace: 'hace 18 minutos' },
  { iniciales: 'PS', nombre: 'Paula S.', ciudad: 'Medellín, Colombia', hace: 'hace 21 minutos' },
  { iniciales: 'RT', nombre: 'Romina T.', ciudad: 'Montevideo, Uruguay', hace: 'hace 24 minutos' },
  { iniciales: 'AN', nombre: 'Antonella N.', ciudad: 'Córdoba, Argentina', hace: 'hace 27 minutos' },
]
